import store from '@/states/index.js'

import UploadComponent from '../UploadComponent.vue'

export default [
    {
        path: '/upload_component',
        component: UploadComponent,
        name: 'upload_component',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]